<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2 class="">
        <span>COPPA Violation Risk</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-coppa-permissions [isFreemium]='isFreemium' [data]="data" (anchorClick)="anchorClick.emit($event)">
      </app-coppa-permissions>
    </div>
  </div>
</div>